import axios from 'axios';
const CONTROLLER_PATH = 'BillingItem';
class BillingItemService {
    //CREATE
    create(formData) {
        return axios
            .post(CONTROLLER_PATH, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then((response) => response.data);
    }

    getBillingItemLink(id) {
        return axios.get(CONTROLLER_PATH + '/GetBillingItemLink/'+id).then((response) => response.data);
    }

    checkStatus(id) {
        return axios.get(CONTROLLER_PATH + '/CheckStatus/'+id);
    }

    convertToAccount(id) {
        return axios.get(CONTROLLER_PATH + '/ConvertToAccount/'+id);
    }

    getMedediStatuses() {
        return axios.get(CONTROLLER_PATH + "/getMedediStatuses").then((response) => response.data);
    }
    getLocalStatuses() {
        return axios.get(CONTROLLER_PATH + "/getLocalStatuses").then((response) => response.data);
    }
    getMedediPlacesOfService() {
        return axios.get(CONTROLLER_PATH + "/getMedediPlacesOfService").then((response) => response.data);
    }

    //UPDATE
    update(id, formData) {
        //formData.append('_method', 'PUT');
        return axios
            .put(CONTROLLER_PATH + '/' + id, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then((response) => response.data);
    }

    //DELETE
    delete(id) {
        return axios.delete(CONTROLLER_PATH + '/' + id).then(() => {});
    }

    //ACCOUNT FILES
    //CREATE
    createFile(billingItemId, formdata) {
        return axios
            .post(CONTROLLER_PATH + "/" + billingItemId + "/file", formdata, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => response.data);
    }
    //UPDATE
    updateFile(entity) {
        return axios.put(CONTROLLER_PATH + "/" + entity.billingItemId + "/file/" + entity.id, entity).then((response) => response.data);
    }
    //DELETE
    deleteFile(billingItemId, accountFileId) {
        return axios.delete(CONTROLLER_PATH + "/" + billingItemId + "/file/" + accountFileId).then((response) => response.data);
    }
}

export default new BillingItemService();
